import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__contest_terms',
    path: '/contest-terms',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/contest-terms.vue' /* webpackChunkName: "pages-car-contest-terms.vue" */
        )
      )
  }
]
